var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserFolderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8999 15.6004C8.8999 13.0029 11.0024 10.9004 13.5999 10.9004H17.6999C18.7952 10.9004 19.8542 11.2792 20.7028 11.9843L20.7044 11.9856L20.7044 11.9856L25.3984 15.9004H34.3999C36.9974 15.9004 39.0999 18.0029 39.0999 20.6004V32.4004C39.0999 34.9979 36.9974 37.1004 34.3999 37.1004H13.5999C11.0024 37.1004 8.8999 34.9979 8.8999 32.4004V15.6004ZM13.5999 13.1004C12.2174 13.1004 11.0999 14.2179 11.0999 15.6004V32.4004C11.0999 33.7829 12.2174 34.9004 13.5999 34.9004H34.3999C35.7824 34.9004 36.8999 33.7829 36.8999 32.4004V20.6004C36.8999 19.2179 35.7824 18.1004 34.3999 18.1004H24.9999C24.7424 18.1004 24.4931 18.0101 24.2954 17.8452L19.297 13.6765C19.2967 13.6763 19.2965 13.6761 19.2963 13.6759C18.845 13.3013 18.2843 13.1004 17.6999 13.1004H13.5999Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1705 22.5604C28.5962 22.5604 28.1305 23.026 28.1305 23.6004C28.1305 24.1747 28.5962 24.6404 29.1705 24.6404C29.7449 24.6404 30.2105 24.1747 30.2105 23.6004C30.2105 23.026 29.7449 22.5604 29.1705 22.5604ZM25.9305 23.6004C25.9305 21.8109 27.3811 20.3604 29.1705 20.3604C30.9599 20.3604 32.4105 21.8109 32.4105 23.6004C32.4105 25.3898 30.9599 26.8404 29.1705 26.8404C27.3811 26.8404 25.9305 25.3898 25.9305 23.6004Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7905 30.3507C23.7905 29.1732 24.743 28.2207 25.9205 28.2207H32.4305C33.608 28.2207 34.5605 29.1732 34.5605 30.3507V32.7507H32.3605V30.4207H25.9905V32.7507H23.7905V30.3507Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFolderLight);
export default __webpack_public_path__ + "static/media/icon_user_folder_light.18c6c52a.svg";
export { ForwardRef as ReactComponent };